// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2014 Minted Inc.
 *
 * All Rights Reserved
 */

// UMD header is generated manually on July 8th
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community/util': []
})(this, function (m_module, Backbone, _) {
  "use strict";

  M.Model = M.Model || {};

  /**
   * @class DropdownPicker
   *
   * Dropdown picker model
   *
   * Arguments:
   * - sortOptionsList: list of sort options that gets displayed in
   *   dropdown.
   *   Format: [{'option_val': 'option1', 'display_str': 'Option One'},...]
   * - selectedSortOption: string specifying option_val of selected option
   */
  M.Model.DropdownPicker = Backbone.Model.extend({

    initialize: function() {
      M.required(this.get('sortOptionsList'));
      M.required(this.get('selectedSortOption'));
    },

    getSelectedSortOption: function () {
      return this.get('selectedSortOption');
    }
  });

  return {
    DropdownPicker: M.Model.DropdownPicker
  };

});
